import { render, staticRenderFns } from "./Effectif.vue?vue&type=template&id=1298f38b&"
import script from "./Effectif.vue?vue&type=script&lang=js&"
export * from "./Effectif.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports